// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sA3u","label":"styles_label__3bnbL"};